import { render, staticRenderFns } from "./StartEfiling.vue?vue&type=template&id=49dc756c&scoped=true"
import script from "./StartEfiling.vue?vue&type=script&lang=ts"
export * from "./StartEfiling.vue?vue&type=script&lang=ts"
import style0 from "./StartEfiling.vue?vue&type=style&index=0&id=49dc756c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dc756c",
  null
  
)

export default component.exports